/*
 * @Description: 自定义指令
 * @Author: Xiaochun liu
 * @Date: 2023-10-11 10:32:53
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-03-07 11:42:41
 */
import type { App } from 'vue'
import drag from './drag'
import reserveSelectTextDirective from './reserve-select-text'
import tooltip from './tooltip/tooltip'

// 全部自定义指令
const directions: any[] = [drag, reserveSelectTextDirective, tooltip]
/**
 * 组件注册
 * @param {App} app Vue 对象
 * @returns {Void}
 */
const install = (app: App) => {
  // 自定义指令注册
  directions.forEach(direction => app.directive(direction.name, direction))
}

// 全部导出 main.ts 中使用use
export default {
  install,
}
